import {
  Breadcrumb,
  PageHeader,
  Table,
  Tooltip,
  Typography,
  Button,
  Tag,
} from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import { stockIssueService } from "_services";
import AvailableStockSearch from "./AvailableStockSearch";
import { CurrencyFormatter } from "_helpers/formatters";

const TiepAvailableStocks = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [genearatingExcel, setGeneratingExcel] = useState(false);
  const [items, setItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null);

  const { Title } = Typography;

  useEffect(() => {
    getAvailablStocks(searchQuery);
  }, [searchQuery]);

  const getAvailablStocks = async (searchQuery) => {
    try {
      setLoading(true);
      const result = await stockIssueService.getAvailableStockReceipts(
        searchQuery
      );
      setItems(result.content);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleSearchResults = (searchParams) => {
    setSearchQuery(searchParams);
  };

  const handleExportExcel = async () => {
    try {
      setGeneratingExcel(true);
      const response = await stockIssueService.exportAvailableStocksExcel(
        searchQuery
      );
      const url = window.webkitURL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Available-Report_${moment(new Date()).format("YYYY-MM-DD")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
    } finally {
      setGeneratingExcel(false);
    }
  };

  const getColumnsOfExpandables = () => {
    const columns = [];

    columns.push({
      title: "Cus.Dec.No#",
      dataIndex: "customRefNumber",
      width: "8%",
      key: "customRefNumber",
    });

    columns.push({
      title: "HS Code",
      dataIndex: "stockTypeCode",
      width: "8%",
      key: "stockTypeCode",
    });

    columns.push({
      title: "Description",
      dataIndex: "stockTypeName",
      width: "25%",
      key: "stockTypeName",
    });

    columns.push({
      title: "Package Type",
      dataIndex: "packingType",
      width: "5%",
      key: "packingType",
    });

    columns.push({
      title: "Nett Weight(KG)",
      dataIndex: "tiepQuantityPerMaterial",
      width: "10%",
      key: "tiepQuantityPerMaterial",
      render: (text, record) => CurrencyFormatter(text ?? ""),
    });

    columns.push({
      title: "Gross Weight(KG)",
      dataIndex: "grossWeight",
      width: "10%",
      key: "grossWeight",
      render: (text, record) => CurrencyFormatter(text ?? ""),
    });

    return columns;
  };

  const getColumns = () => {
    const columns = [];

    columns.push({
      title: "Cus.Dec.No#",
      dataIndex: "availableStockByReceiptViews",
      width: "25%",
      key: "availableStockByReceiptViews",
      render: (customRefNumber, record) => (
        <>
          {(customRefNumber || []).map((item, index) => (
            <Tag
              color="#13c2c2"
              key={index}
              // style={{ fontSize: "14px", padding: "2px 8px" }}
            >
              {item.customRefNumber}
            </Tag>
          ))}
        </>
      ),
    });

    columns.push({
      title: "HS Code",
      dataIndex: ["stockType"],
      width: "10%",
      key: "stockType",
    });
    columns.push({
      title: "Description",
      width: "25%",
      key: "stockTypeName",
      dataIndex: ["stockTypeName"],
      ellipsis: {
        showTitle: false,
      },
    });

    columns.push({
      title: "Nett Weight(kg)",
      width: "15%",
      key: "totalNetWeight",
      dataIndex: ["totalNetWeight"],
      render: (text, record) => CurrencyFormatter(text),
    });

    columns.push({
      title: "Gross Weight(kg)",
      width: "15%",
      key: "totalGrossWeight",
      dataIndex: ["totalGrossWeight"],
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => CurrencyFormatter(text),
    });

    return columns;
  };

  const onCancel = () => {
    history.push("/reports/available-stocks");
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Tooltip
        key="export-excel-tooltip"
        placement="topLeft"
        title="EXPORT EXCEL"
      >
        <Button
          key="export-excel"
          icon={<FilePdfOutlined />}
          onClick={(e) => {
            e.preventDefault();
            handleExportExcel();
          }}
          loading={genearatingExcel}
        >
          Export Excel
        </Button>
      </Tooltip>
    );

    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/reports">Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Available Stocks</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <>
            <AvailableStockSearch onSearch={handleSearchResults} />

            {/* {!dateFilter && (
              <Title level={5} style={{ marginTop: 20 }}>
                As of: {moment().format("YYYY-MM-DD")}
              </Title>
            )}
            {dateFilter && (
              <Title level={5} style={{ marginTop: 20 }}>
                As of: From:{moment(fromDate).format("YYYY-MM-DD")} - To:
                {moment(toDate).format("YYYY-MM-DD")}
              </Title>
            )} */}
            {/* {items && items.length > 0 && (
              <div
                style={{
                  background: "#ECECEC",
                  padding: "15px",
                  marginBottom: 15,
                }}
              >
                <Row gutter={24}>
                  <Col span={7}>
                    <Card style={{ justifyItems: "center" }}>
                      <Statistic
                        title="Total Package Quantity(Kg)"
                        value={items.reduce(
                          (sum, item) =>
                            item.uom.name === "KG"
                              ? sum + item.totalQuantity
                              : sum,
                          0
                        )}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>

                  <Col span={7}>
                    <Card style={{ justifyItems: "center" }}>
                      <Statistic
                        title="Total Package Quantity(Nos)"
                        value={items.reduce(
                          (sum, item) =>
                            item.uom.name === "NOS"
                              ? sum + item.totalQuantity
                              : sum,
                          0
                        )}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>

                  <Col span={7}>
                    <Card style={{ justifyItems: "center" }}>
                      <Statistic
                        title="Total Duty"
                        precision={2}
                        suffix="LKR"
                        value={items.reduce(
                          (sum, item) => sum + item.dutyValue,
                          0
                        )}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>

                  <Col span={3}>
                    <Button
                      type="primary"
                      onClick={handleExportExcel}
                      style={{
                        width: "100%",
                        height: "auto",
                        // padding: "0.5rem",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        fontSize: "0.8rem",
                      }}
                      loading={loadingExcel}
                    >
                      Export to Excel
                    </Button>
                  </Col>
                </Row>
              </div>
            )} */}
            <Table
              bordered
              loading={loading}
              size="small"
              rowKey="id"
              columns={getColumns()}
              dataSource={items}
              pagination={false}
              expandable={{
                expandedRowRender: (record) => (
                  <div>
                    <Table
                      bordered
                      size="small"
                      columns={getColumnsOfExpandables()}
                      dataSource={record.availableStockByReceiptViews || []}
                    />
                  </div>
                ),
                rowExpandable: (record) =>
                  record.availableStockByReceiptViews?.length > 0,
                expandIconColumnIndex: 0,
              }}
              className="custom-expand-icon"
            />
          </>
        </Page>
      </PageHeader>
    </>
  );
};

export default TiepAvailableStocks;
